import { render, staticRenderFns } from "./ObligList.vue?vue&type=template&id=597b1438&scoped=true&"
import script from "./ObligList.vue?vue&type=script&lang=js&"
export * from "./ObligList.vue?vue&type=script&lang=js&"
import style0 from "./ObligList.vue?vue&type=style&index=0&id=597b1438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597b1438",
  null
  
)

export default component.exports